import React from "react";
import { useHistory } from "react-router-dom";
import ROUTES from "../../../../../AppRouter/routes";
import CollectionMethodForm from "./CollectionMethodForm";
import { connect } from "react-redux";
import { findLatestVersion } from "../../../../../../utils/helpers";

const Index = (props) => {
  const {
    onSave,
    collectionMethods,
    values,
    possibleVectorTypes,
    ...otherProps
  } = props;

  const history = useHistory();
  const onDiscardChanges = () => {
    history.push(ROUTES.collectionMethods);
  };

  const onSubmit = async (formValues) => {
    try {
      const finalTrapType = formValues.trapType === "Other" ? formValues.otherTrapType : formValues.trapType;

      const finalAttractantType = Array.isArray(formValues.attractantType)
        ? formValues.attractantType.filter(item => item !== "Other")
        : [];

      if (
        formValues.attractantType?.includes("Other") &&
        formValues.otherAttractantType
      ) {
        finalAttractantType.push(formValues.otherAttractantType);
      }

      const payload = {
        ...formValues,
        trapType: finalTrapType || "",
        attractantType: finalAttractantType,
      };

      delete payload.otherTrapType;
      delete payload.otherAttractantType;
      console.log("Form Value Attractant:", formValues.attractantType);
      console.log("Form Submitted with values:", payload);
      return onSave(payload);
    } catch (err) {
      console.error('Error occurred while saving the collection method', err);
    }

  };

  return (
    <div>
      <CollectionMethodForm
        {...otherProps}
        onSubmit={onSubmit}
        onDiscardChanges={onDiscardChanges}
        possibleVectorTypes={possibleVectorTypes}
      />
    </div>
  );
};
//aa
export const mapStateToProps = (state) => {
  const { selectedDevice, ...devices } = state.devices;
  const algVersions = Object.values(devices).reduce((pre, cur) => {
    if (cur?.algVersion) {
      return [...pre, cur?.algVersion];
    }
    return pre;
  }, []);
  const latestAlgVersion = findLatestVersion(algVersions);
  return {
    collectionMethods: state.collectionMethods,
    possibleVectorTypes: state?.algVersion?.[latestAlgVersion] || {
      mosquito: {},
      tick: {},
    },
  };
};

export default connect(mapStateToProps, {})(Index);
